
import VueRouter from 'vue-router'
import Spot from './components/Spot.vue'
import store from './store'

const router = new VueRouter({
  routes: [
    {
      path: '/spots/:spot_id',
      component: Spot
    }
  ]
})

router.afterEach((to, from) => {
  // console.log(`Router: ${from}->${to}`)
  if (to.path.match(/^\/spots\//)) {
    // console.log('Change Spot Id')
    store.commit('selectSpotData', to.params.spot_id)
  }
})

export default router
